import React, { useCallback } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import {
  ackAdminMessage,
  dismissAdminMessage,
  seenAdminMessage,
} from "../api/adminMessagesApi";
import { useRemindersHub } from "../context/RemindersHubContext";

export default function AdminBroadcastModal() {
  const {
    currentPopup,
    optimisticSkipPopup,
    revertOptimisticPopupSkip,
    refreshActiveAdmin,
    refreshSummary,
  } = useRemindersHub();

  const onOpen = useCallback(async () => {
    if (!currentPopup?.id) return;
    try {
      await seenAdminMessage(currentPopup.id);
    } catch {
      /* ignore */
    }
  }, [currentPopup]);

  const handleAck = async () => {
    const id = currentPopup?.id;
    if (id == null) return;
    optimisticSkipPopup(id);
    try {
      await ackAdminMessage(id);
      await refreshActiveAdmin();
      await refreshSummary();
    } catch {
      revertOptimisticPopupSkip(id);
    }
  };

  const handleDismiss = async () => {
    const id = currentPopup?.id;
    if (id == null) return;
    optimisticSkipPopup(id);
    try {
      await dismissAdminMessage(id);
      await refreshActiveAdmin();
      await refreshSummary();
    } catch {
      revertOptimisticPopupSkip(id);
    }
  };

  if (!currentPopup) return null;

  const needAck = Boolean(currentPopup.require_acknowledgement);
  const cta = currentPopup.cta_link && currentPopup.cta_text;

  return (
    <Dialog
      open
      onClose={needAck ? undefined : handleDismiss}
      maxWidth="sm"
      fullWidth
      TransitionProps={{ onEntered: onOpen }}
    >
      <DialogTitle>{currentPopup.title}</DialogTitle>
      <DialogContent>
        {currentPopup.image_url ? (
          <img
            src={currentPopup.image_url}
            alt=""
            style={{ maxWidth: "100%", borderRadius: 8, marginBottom: 12 }}
          />
        ) : null}
        {currentPopup.body ? (
          <Typography variant="body1" component="div" style={{ whiteSpace: "pre-wrap" }}>
            {currentPopup.body}
          </Typography>
        ) : null}
      </DialogContent>
      <DialogActions sx={{ flexWrap: "wrap", gap: 1, padding: 2 }}>
        {cta ? (
          <Button
            component="a"
            href={currentPopup.cta_link}
            target="_blank"
            rel="noopener noreferrer"
            variant="outlined"
          >
            {currentPopup.cta_text}
          </Button>
        ) : null}
        {needAck ? (
          <Button variant="contained" color="primary" onClick={handleAck}>
            הבנתי
          </Button>
        ) : (
          <Button variant="contained" onClick={handleDismiss}>
            סגור
          </Button>
        )}
        {needAck ? (
          <Button onClick={handleDismiss} color="inherit">
            התעלם
          </Button>
        ) : null}
      </DialogActions>
    </Dialog>
  );
}
